export default __webpack_public_path__ + "static/media/save.a9b279a8.svg";